import { useId } from "react";
import { Controller, RegisterOptions, useFormContext } from "react-hook-form";
import { SelectItem, SelectNewOption } from "../select/Select";
import AsyncSelect from "../select/AsyncSelect";
import { GroupBase, OptionsOrGroups } from "react-select";

interface AsyncSelectProps {
  name: string;
  placeholder?: string;
  required?: boolean;
  className?: string;
  options?: RegisterOptions;
  isMulti?: boolean;
  newOption?: SelectNewOption;
  loadOptions: (
    inputValue: string,
    callback: (
      options: OptionsOrGroups<SelectItem, GroupBase<SelectItem>>,
    ) => void,
  ) => Promise<void>;
  multivalueTagLabelKey?: string;
  isDisabled?: boolean;
  enableDefaultOptions?: boolean;
}

const AsyncSelectInput = (props: AsyncSelectProps) => {
  const instanceId = useId();
  const { control, getFieldState, formState } = useFormContext();

  const { invalid, isDirty, error } = getFieldState(props.name, formState);

  const showError = !!error && isDirty;

  return (
    <div className="mb-2">
      <Controller
        name={props.name}
        control={control}
        rules={props.options}
        render={({ field }) => (
          <AsyncSelect
            {...field}
            isMulti={props.isMulti}
            placeholder={props.placeholder}
            invalid={invalid}
            newOption={props.newOption}
            loadOptions={props.loadOptions}
            multivalueTagLabelKey={props.multivalueTagLabelKey}
            isDisabled={props.isDisabled}
            enableDefaultOptions={props.enableDefaultOptions}
            instanceId={instanceId}
          />
        )}
      />
      {showError && (
        <div className="text-error mt-1 text-[13px]">{error.message}</div>
      )}
    </div>
  );
};

export default AsyncSelectInput;
